import { IcFocus } from '@assets/icons/40x40/mapMenu';
import { Icon } from '@chakra-ui/react';
import { useMapContext } from '@components/map/MapContext';
import { ButtonBar } from '@components/ui/buttonBar';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveGlobalScreenConfiguration } from '@redux/config/config.selectors';
import { useIntl } from 'react-intl';

function CenterMapControl() {
  const { map } = useMapContext();
  const { formatMessage } = useIntl();

  const activeGlobalScreenConfig = useAppSelector(selectActiveGlobalScreenConfiguration);

  return (
    <ButtonBar.Root
      aria-label={formatMessage({ id: 'controls.toolMenu.center' })}
      notchPlacement="bottom-left"
      tooltipPlacement="left"
      disabled={!activeGlobalScreenConfig}
      onClick={() =>
        activeGlobalScreenConfig &&
        map?.flyTo({
          center: [activeGlobalScreenConfig.position.longitude, activeGlobalScreenConfig.position.latitude],
          zoom: 14,
        })
      }
    >
      <ButtonBar.Control>
        <Icon as={IcFocus} />
      </ButtonBar.Control>
    </ButtonBar.Root>
  );
}

export default CenterMapControl;
